export default "__VITE_ASSET__14ea489f__"